import type { FC } from 'react';

import { Route, Routes } from 'react-router-dom';

import { Login, RouterAuthHOC } from 'auth';
import { Layout } from 'components';
import { ModalsManager } from 'modals';

import { InitializationHOC } from './components/InitializationHOC';
import { ROUTES } from './routes';

const App: FC = () => (
  <InitializationHOC>
    <ModalsManager />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        {ROUTES.map(({ permission, ...route }) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <RouterAuthHOC permission={permission}>
                {route.component}
              </RouterAuthHOC>
            }
          ></Route>
        ))}
      </Route>
    </Routes>
  </InitializationHOC>
);

export default App;
